const tabs = {
    platform_settings: 'تنظیمات پلتفرم',
    actions: 'Actions',
    get_started: 'شروع کنید',
    dashboard: 'داشبورد',
    applications: 'برنامه‌ها',
    api_resources: 'منابع API',
    sign_in_experience: 'ورود و حساب',
    connectors: 'اتصال‌دهنده‌ها',
    enterprise_sso: 'SSO سازمانی',
    security: 'امنیت',
    webhooks: 'وب‌هوک‌ها',
    organizations: 'سازمان‌ها',
    users: 'مدیریت کاربران',
    audit_logs: 'گزارش‌های ممیزی',
    roles: 'نقش‌ها',
    docs: 'مستندات',
    tenant_settings: 'تنظیمات',
    mfa: 'احراز هویت چندعاملی',
    customize_jwt: 'JWT سفارشی',
    signing_keys: 'کلیدهای امضا',
    organization_template: 'قالب سازمان',
};
export default Object.freeze(tabs);
